import {PROCESSING_ACTIONS} from "../actions/types";

const defaultState = {

};

const _inc = what => {
	if (what === undefined) {
		return 1;
	}
	return what + 1;
};

const _dec = what => {
	if (what === undefined || what <= 0) {
		return 0;
	}
	return what - 1;
};

export default (state = defaultState, {type, id}) => {
	switch (type) {
		case PROCESSING_ACTIONS.ADD:
			return {
				...state,
				[id]: _inc(state[id])
			};
		case PROCESSING_ACTIONS.REMOVE:
			return {
				...state,
				[id]: _dec(state[id])
			};
		case PROCESSING_ACTIONS.CLEAR:
			return defaultState;
		default:
			return state;
	}
};


// WEBPACK FOOTER //
// ./src/reducers/processingReducer.js